//
import Model from '@/models/Model'

/**
 * @class
 */
export default class PchDetailPurchaseOrder extends Model {
    /**
     *
     */
    get code() {
        return this.wh_product_service ? this.provider_product_code : this.wh_product_internal_code
    }

    /**
     *
     */
    get name() {
        return this.wh_product_service ? this.wh_product_service.name : this.wh_product.name
    }

    /**
     *
     */
    get wh_product_internal_code() {
        return this.wh_product.internal_code
    }

    /**
     *
     */
    get wh_product_name() {
        return this.wh_product.name
    }

    /**
     *
     */
    resource() {
        return 'pch_detail_purchase_quotation'
    }
}
